export const PROSPECT_DEMO_REFERENCE_EXECUTION_CATALOG = Object.freeze([
    Object.freeze({
        id: "beauty.salons.reference-v2",
        industryKey: "beauty",
        nicheKey: "salons",
        solutionKey: "salons-operations",
        templateKey: null,
        runtimeStatus: "requires-organization",
        cloneEligible: true,
        target: Object.freeze({
            kind: "platform-path",
            path: "/o/salon-demo/salons",
            requiredOrganizationSlug: "salon-demo",
        }),
    }),
    Object.freeze({
        id: "gastronomy.reference-restaurant-v1",
        industryKey: "gastronomy",
        nicheKey: "restaurant",
        solutionKey: "restaurant-system",
        templateKey: null,
        runtimeStatus: "available",
        cloneEligible: true,
        target: Object.freeze({
            kind: "platform-path",
            path: "/demos?reference=casa-nativa&section=inicio",
        }),
    }),
    Object.freeze({
        id: "home-services.renovation.maison-morel-v1",
        industryKey: "home-services",
        nicheKey: "renovation",
        solutionKey: "lead-conversion",
        templateKey: "renovation-general-v1",
        runtimeStatus: "branch-scoped",
        cloneEligible: false,
        target: Object.freeze({
            kind: "unavailable",
            reason: "The Maison Morel reference remains branch-scoped and is not executable from main.",
        }),
    }),
    Object.freeze({
        id: "hospitality.accommodation.reference-pending",
        industryKey: "hospitality",
        nicheKey: "accommodation",
        solutionKey: "direct-booking",
        templateKey: null,
        runtimeStatus: "missing",
        cloneEligible: false,
        target: Object.freeze({
            kind: "unavailable",
            reason: "Hospitality does not yet have a unified executable Reference Demo in main.",
        }),
    }),
]);
export function prospectDemoReferenceExecution(id) {
    return (PROSPECT_DEMO_REFERENCE_EXECUTION_CATALOG.find((candidate) => candidate.id === id) ?? null);
}
//# sourceMappingURL=prospect-demo-reference.js.map